var _circle, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFaqs18(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 61,
    stroke: "#339999",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.7631 49.1592V84.7164",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6682 61.8582H76.6208",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6682 51.699H76.6208",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4763 77.097C38.8195 77.097 38.1897 76.8294 37.7253 76.3531C37.2609 75.8768 37 75.2308 37 74.5572V41.5398C37 40.8662 37.2609 40.2202 37.7253 39.7439C38.1897 39.2676 38.8195 39 39.4763 39H51.8578C54.4849 39 57.0043 40.0703 58.8619 41.9756C60.7195 43.8808 61.7631 46.4648 61.7631 49.1592C61.7631 46.4648 62.8066 43.8808 64.6642 41.9756C66.5218 40.0703 69.0412 39 71.6683 39H84.0498C84.7066 39 85.3364 39.2676 85.8008 39.7439C86.2652 40.2202 86.5261 40.8662 86.5261 41.5398V74.5572C86.5261 75.2308 86.2652 75.8768 85.8008 76.3531C85.3364 76.8294 84.7066 77.097 84.0498 77.097H69.192C67.2217 77.097 65.3321 77.8998 63.9389 79.3287C62.5457 80.7576 61.7631 82.6956 61.7631 84.7164C61.7631 82.6956 60.9804 80.7576 59.5872 79.3287C58.194 77.8998 56.3044 77.097 54.3341 77.097H39.4763Z",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9053 61.8582H51.8579",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9053 51.699H51.8579",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFaqs18);
export default __webpack_public_path__ + "static/media/IconFaqs18.44c75d6b8fcbcb2a09366793c391e44d.svg";
export { ForwardRef as ReactComponent };